import {language as en} from './en/text';
import {language as de} from './de/text';
import {Ilanguage} from "../../../interface/Icommon";


export const language: Ilanguage = {en, de}